module.exports = __webpack_public_path__ + "static/img/04.5b87d36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/04.png
// module id = s9Uz
// module chunks = 1